<template>
  <div class="container">
    <div class="row">
      <div class="col-lg-3 col-md-2"></div>
        <Login/>
    </div>
  </div>
</template>

<script>
import Login from "@/panel/components/Login/index.vue";
export default {
  name: "loginLayout",
  components:{ Login },
  created() {
     // this.clearCache();
  },
  methods:{
    clearCache(){
      localStorage.clear();
    }
  }
}
</script>

<style scoped>

</style>